.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  padding: 0 map.get($spacing-scale, 'md');
  background-color: var(--color-surface-primary);
  border-bottom: 1px solid var(--color-grey-soft);
  cursor: pointer;
  user-select: none;

  @include transition(background-color);

  &:hover:not(.disabled):not(.selected) {
    background-color: var(--color-grey-light);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-base);
    outline-offset: -2px;
  }
}

.selected {
  background: linear-gradient(
    90deg,
    rgba(var(--color-primary-base-rgb), 0.08) 0%,
    rgba(var(--color-primary-base-rgb), 0.04) 100%
  );

  // Fallback for browsers that don't support RGB variable
  background: var(--color-primary-light);
  opacity: 1;

  // Better approach using CSS custom property with alpha
  background: color-mix(in srgb, var(--color-primary-base) 8%, var(--color-surface-primary));
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

// Muted state - greyed out but still clickable (for NotOK leads)
.muted {
  .label,
  .subtitle,
  .value,
  .statusIcon {
    color: var(--color-text-tertiary);
  }
}

// Semantic tones — terminal lead.status states (Lost / Converted).
// Selected state still wins; tones apply on non-selected rows + hover.
.toneSuccess:not(.selected) {
  background-color: color-mix(in srgb, var(--color-semantic-success) 12%, var(--color-surface-primary));

  &:hover:not(.disabled) {
    background-color: color-mix(in srgb, var(--color-semantic-success) 20%, var(--color-surface-primary));
  }
}

.toneDanger:not(.selected) {
  background-color: color-mix(in srgb, var(--color-semantic-danger) 12%, var(--color-surface-primary));

  &:hover:not(.disabled) {
    background-color: color-mix(in srgb, var(--color-semantic-danger) 20%, var(--color-surface-primary));
  }
}

.labelContainer {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.label {
  @include body-small-medium;

  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subtitle {
  @include metadata-regular;

  color: var(--color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.valueContainer {
  display: flex;
  align-items: center;
  gap: map.get($spacing-scale, 's-2');
  flex-shrink: 0;
}

.value {
  @include body-small-medium;

  color: var(--color-text-primary);
  min-width: 50px;
  text-align: right;
  flex-shrink: 0;
}

.statusIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--color-text-primary);
}
